export function entitiesInFeedOrder(feed, entities, feedName) {
  return feed.map(item => {
    const entity = entities[item.id];
    if (entity === undefined) {
      throw new Error(
        `${feedName} lists ${item.type} ${item.id}, but the ${item.type} entity store has no entity ${item.id}; `
        + "a smart feed answer always carries the entities of its rows, so the store and the feed disagree",
      );
    }
    return entity;
  });
}
